import { CheckCircleIcon, UserGroupIcon, XIcon } from '@heroicons/react/solid'
import { useFormikContext } from 'formik'
import BussinessFilter from 'pop-up/components/operators-list/BussinessFilter'
import OperatorsList from 'pop-up/components/operators-list/OperatorsList'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import Button from 'shared/components/base/button/BaseButton'
import Modal from 'shared/components/base/pop-up/Modal'
import { RootState } from 'store/store'

import { formikValuesType } from '../..'

const unitBusiness = [
  'میلگرد',
  'نبشی و ناودانی',
  'تیرآهن',
  'استیل',
  'سیم و کابل',
  'صنایع مفتولی',
  'ورق سیاه',
  'ورق سرد',
  'ورق آلیاژی',
  'مانسمان',
  'پروفیل',
  'لوله و اتصالات',
]

type PropType = {
  isVisible: boolean
  onClose: () => void
}
const FactorTarkibiModal = (props: PropType) => {
  const { isVisible, onClose } = props
  const [teamNameFilter, setTeamNameFilter] = useState('')
  const { values, setFieldValue, isSubmitting, submitForm } =
    useFormikContext<formikValuesType>()
  const isHangup = useSelector(
    (state: RootState) => state.callDetail.callData.isHangup
  )

  return (
    <Modal
      className="flex flex-col p-0 "
      onClose={onClose}
      closable={false}
      visible={isVisible}
    >
      <div className="flex text-center justify-between bg-[linear-gradient(270deg,#E6E6FF_0%,#F9F9FE_100%)] w-full py-2 ">
        <span className="flex text-[#5F41B2]">
          <UserGroupIcon className="w-4 h-4 mt-0.5 ml-2 mr-4" />
          ترکیبی و اتصال به کارشناس بعدی
        </span>
        <XIcon
          className="w-4 h-4 ml-8 cursor-pointer mt-1 text-[#666B83]"
          onClick={() => onClose()}
        />
      </div>
      <div className="flex pt-8 w-[1180px] pb-5 pl-7 h-[580px] gap-x-5 pr-11">
        <div className="flex-col w-[650px]">
          <BussinessFilter
            teams={unitBusiness}
            label="تیم ها"
            value={teamNameFilter}
            onChange={setTeamNameFilter as any}
          />
          {/* <div className="flex font-normal text-3.25 leading-7 gap-x-2 text-[#414952] items-center ">
            <PencilAltIcon className="w-4 h-4 " />
            درج یادداشت برای کارشناس بعدی:
          </div>
          <FormikInput
            inputClassName=" w-full h-[71px]"
            className="flex-1 max-w-[566px]"
            name="tarkibi-note"
          /> */}
        </div>
        <div className="flex flex-col w-[532px] rounded-2 border-[#E2E2E2] pt-[17px] border-1 px-8 relative">
          <OperatorsList
            title="لیست کارشناسان"
            selectedOperator={values.selectedOperator as any}
            setSelectedOperator={(newOperator) => {
              setFieldValue('selectedOperator', newOperator)
            }}
            defaultSearch={teamNameFilter}
          />
        </div>
      </div>
      <div className="self-end pb-5 ml-6">
        <Button
          className=" py-4 bg-red-light  text-[14px] font-semibold text-white rounded-2 mr-[40px]"
          rightIcon={<CheckCircleIcon className="w-5 h-5" />}
          type="submit"
          color="red"
          loading={isSubmitting}
          onClick={submitForm}
          disabled={isHangup}
        >
          ثبت آپورچونیتی و اتصال به کارشناس بعدی
        </Button>
      </div>
    </Modal>
  )
}

export default FactorTarkibiModal
